import React, {useState, useTransition} from 'react';
import {useUser} from "../../hooks/useUser";
import AdvanceTableWrapper from "../../components/common/advance-table/AdvanceTableWrapper";
import IndexTableHeader from "../../components/common/headers/IndexTableHeader";
import AdvanceTable from "../../components/common/advance-table/AdvanceTable";
import AdvanceTableFooter from "../../components/common/advance-table/AdvanceTableFooter";
import NewPractitionerModal from "./NewPractitionerModal";
import {Card} from "react-bootstrap";
import {LinkCell} from "../../components/common/advance-table/CustomCells";
import {useRefetchableFragment} from "react-relay";
import graphql from "babel-plugin-relay/macro";
import PractitionerFilters from "./PractitionerFilters";

const columns = [
    {
        accessor: "applicableVersion.displayName",
        Header: "Name",
        headerProps: {className : "pe-1"},
        cellProps: {
            className: 'py-2'
        },
        Cell: rowData => {
            const { applicableVersion, id} = rowData.row.original;
            return <LinkCell name={applicableVersion.displayName}
                             to={"/practitioners/" + id} hasAvatar />
        }
    },
    {
        accessor: "npi",
        Header: "NPI",
        filter: "includes"
    },
    {
        accessor: "legalContract.name",
        Header: "Contract",
        headerProps: {className: "pe-1"},
        filter: "includes",
        cellProps: {
            className: 'py-2'
        },
        Cell: rowData => {
            const {legalContract} = rowData.row.original;
            return <LinkCell name={legalContract.name} to={"/contracts/" + legalContract.id} />
        }
    }
];
const PractitionersTable = ({practitioners, allLegalContracts}) => {
    const [params, setParams] = useState({
        
    })
    const [data, refetch] = useRefetchableFragment(
        graphql`
            fragment PractitionersTableFragment on Query
            @refetchable(queryName: "PractitionersTableRefetch")
            @argumentDefinitions(
                firstName: {type: "String", defaultValue: null}
                lastName: {type: "String", defaultValue: null}
                npi: {type: "String", defaultValue: null}
                tin: {type: "String", defaultValue: null}
                legalContractName: {type: "String", defaultValue: null}
                locationName: {type: "String", defaultValue: null}
            )
            {
                filteredPractitioners(input: {firstName: $firstName, lastName: $lastName, npi: $npi, tIN: $tin,
                    legalContractName: $legalContractName, locationName: $locationName}) {
                    id
                    legalContract {
                        id
                        name
                    }
                    identifiers {
                        identifierType {
                            code
                        }
                        value
                    }
                    applicableVersion {
                        displayName
                    }
                }
            }`
    , practitioners);
    const [isPending, startTransition] = useTransition();
    const [showModal, setShowModal] = useState(false);
    const {hasPermission} = useUser();
    const onParamsChange = (e) => {
        setParams({...params, [e.target.name]: e.target.value});
    }
    
    const onParamEnter = (e) => {
        if(e.key === "Enter") onSearch();
    }
    const onSearch = () => {
        startTransition(() => {
            refetch({...params})
        });
    }
    
    const onClearFilters = () => {
        setParams({});
    }
    const mappedData = data.filteredPractitioners.map(d => {
        return {
            ...d, npi: Array.from(new Set(d.identifiers?.filter(x => x.identifierType.code === "NPI").map(y => {return y.value}))).toSorted().join(", ")
        }
    })
    return (
        <><Card className={"mb-1"}>
            <PractitionerFilters params={params}
                                 onParamsChange={onParamsChange}
                                 onParamsEnter={onParamEnter}
                                 onSearch={onSearch}
                                 onClearFilters={onClearFilters}
                                 isLoading={isPending}
            />
        </Card>
            <AdvanceTableWrapper
                columns={columns}
                data={mappedData}
                sortable
                pagination
                perPage={10}
            >
                <Card className="mb-3">
                    <Card.Header>
                        <IndexTableHeader name={"Practitioners"}
                                          onNewClick={() => {setShowModal(true)}}
                                          table
                                          showNew={hasPermission("Practitioner.Create")}
                                          showSearch={false}
                        />
                    </Card.Header>
                    <Card.Body className="p-0">
                        <AdvanceTable
                            table
                            isLoading={true}
                            headerClassName="bg-200 text-900 text-nowrap align-middle"
                            rowClassName="align-middle white-space-nowrap"
                            tableProps={{
                                size: 'sm',
                                striped: true,
                                className: 'fs--1 mb-0 overflow-hidden'
                            }}
                        />
                    </Card.Body>
                    <Card.Footer>
                        <AdvanceTableFooter
                            table
                            rowInfo
                            rowCount={data.filteredPractitioners.length}
                            navButtons
                            rowsPerPageSelection
                        />
                    </Card.Footer>
                </Card>
            </AdvanceTableWrapper>
            <NewPractitionerModal showModal={showModal}
                                  onClose={() => {setShowModal(false)}}
                                  contracts={allLegalContracts}
            />
        </>
    )
}
export default PractitionersTable